import { Validators } from '@angular/forms';
import { Formulario } from '../../interface/fomulario';

export class RecogidaMenores implements Formulario {
    createFormulario(): any[] {
        const form = [{element: 'text', name: 'fullname', label: 'Nombres y apellidos*', validations: [Validators.required]},
        {element: 'number', name: 'age', label: 'Edad*', validations: [Validators.required]}, {reference: 'relationship',
        element: 'select', name: 'relationship', label: 'Parentesco*', options: [], referenceName: 'name',
         referenceValue: 'name', validations: [Validators.required]}, {element: 'text', name: 'dni', label: 'DNI/NIE*',
          validations: [Validators.required]}, {element: 'number', name: 'phone', label: 'Teléfono*', validations: [Validators.required]}
    ];
        return form;
    }
}
